/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Keydisplayname2Inputs */

const en_entity_keydisplayname2 = /** @type {(inputs: Entity_Keydisplayname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Display Name`)
};

const de_entity_keydisplayname2 = /** @type {(inputs: Entity_Keydisplayname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Key Display Name" |
*
* @param {Entity_Keydisplayname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_keydisplayname2 = /** @type {((inputs?: Entity_Keydisplayname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Keydisplayname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_keydisplayname2(inputs)
	return de_entity_keydisplayname2(inputs)
});
export { entity_keydisplayname2 as "entity_keyDisplayName" }